import { InternetRecommender } from '../../../InternetRecommender';
import React from 'react';

const CmsInternetRecommender = ({
  variant,
  visible,
  unavailableSite,
  availableSite,
  bauvorhabenSite,
}) => (
  <InternetRecommender
    availableSite={availableSite}
    bauvorhabenSite={bauvorhabenSite}
    isVisible={!!visible}
    unavailableSite={unavailableSite}
    variant={variant}
  />
);

export default CmsInternetRecommender;
